var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var WebSocketService = (function () {
    function WebSocketService() {
        this.ws = null;
        this.url = '';
        this.reconnectAttempts = 0;
        this.maxReconnectAttempts = 5;
        this.reconnectInterval = 3000;
        this.messageHandlers = [];
        this.isConnected = false;
        this.heartbeatIntervalId = null;
        this.heartbeatInterval = 600000;
        this.token = undefined;
        this.robotCode = undefined;
    }
    WebSocketService.getInstance = function () {
        if (!WebSocketService.instance) {
            WebSocketService.instance = new WebSocketService();
        }
        return WebSocketService.instance;
    };
    WebSocketService.prototype.connect = function (url, token, robotCode) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                _this.url = url;
                _this.token = token;
                _this.robotCode = robotCode;
                var wsUrl = url;
                var params = [];
                params.push("source=1");
                params.push("type=ai_assistant");
                params.push("client_type=100");
                if (token)
                    params.push("token=" + encodeURIComponent(token));
                if (robotCode)
                    params.push("robot_code=" + encodeURIComponent(robotCode));
                if (params.length)
                    wsUrl += (url.indexOf('?') === -1 ? '?' : '&') + params.join('&');
                _this.ws = new WebSocket(wsUrl);
                _this.ws.onopen = function () {
                    console.log('WebSocket连接已建立');
                    _this.isConnected = true;
                    _this.reconnectAttempts = 0;
                    _this.startHeartbeat();
                    resolve();
                };
                _this.ws.onmessage = function (event) {
                    try {
                        var message = JSON.parse(event.data);
                        if (message === 'pong' || (typeof message === 'object' && message && message.toString() === 'pong')) {
                            console.log('收到心跳响应：pong');
                        }
                        else {
                            _this.notifyHandlers(message);
                        }
                    }
                    catch (error) {
                        if (event.data === 'pong') {
                            console.log('收到心跳响应：pong');
                        }
                        else {
                            console.error('解析WebSocket消息失败:', error);
                        }
                    }
                };
                _this.ws.onclose = function () {
                    console.log('WebSocket连接已关闭');
                    _this.isConnected = false;
                    _this.clearHeartbeat();
                    _this.attemptReconnect();
                };
                _this.ws.onerror = function (error) {
                    console.error('WebSocket连接错误:', error);
                    _this.isConnected = false;
                    reject(error);
                };
            }
            catch (error) {
                reject(error);
            }
        });
    };
    WebSocketService.prototype.attemptReconnect = function () {
        var _this = this;
        if (this.reconnectAttempts < this.maxReconnectAttempts) {
            this.reconnectAttempts++;
            console.log("\u5C1D\u8BD5\u91CD\u8FDE (" + this.reconnectAttempts + "/" + this.maxReconnectAttempts + ")");
            setTimeout(function () {
                if (!_this.isConnected && _this.url) {
                    _this.connect(_this.url);
                }
            }, this.reconnectInterval);
        }
        else {
            console.error('WebSocket重连失败，已达到最大重试次数');
        }
    };
    WebSocketService.prototype.disconnect = function () {
        if (this.ws) {
            this.ws.close();
            this.ws = null;
        }
        this.isConnected = false;
        this.messageHandlers = [];
        this.clearHeartbeat();
    };
    WebSocketService.prototype.sendMessage = function (message) {
        if (this.ws && this.isConnected) {
            var msgWithExtra = __assign({}, message, { client_type: 100, token: this.token, robot_code: this.robotCode });
            this.ws.send(JSON.stringify(msgWithExtra));
        }
        else {
            console.error('WebSocket未连接，无法发送消息');
        }
    };
    WebSocketService.prototype.addMessageHandler = function (handler) {
        this.messageHandlers.push(handler);
    };
    WebSocketService.prototype.removeMessageHandler = function (handler) {
        var index = this.messageHandlers.indexOf(handler);
        if (index > -1) {
            this.messageHandlers.splice(index, 1);
        }
    };
    WebSocketService.prototype.notifyHandlers = function (message) {
        this.messageHandlers.forEach(function (handler) {
            try {
                handler(message);
            }
            catch (error) {
                console.error('消息处理器执行失败:', error);
            }
        });
    };
    WebSocketService.prototype.getConnectionStatus = function () {
        return this.isConnected;
    };
    WebSocketService.prototype.startHeartbeat = function () {
        var _this = this;
        this.clearHeartbeat();
        this.heartbeatIntervalId = setInterval(function () {
            if (_this.ws && _this.isConnected) {
                _this.ws.send('ping');
                console.log('发送心跳：ping');
            }
        }, this.heartbeatInterval);
    };
    WebSocketService.prototype.clearHeartbeat = function () {
        if (this.heartbeatIntervalId) {
            clearInterval(this.heartbeatIntervalId);
            this.heartbeatIntervalId = null;
        }
    };
    return WebSocketService;
}());
export default WebSocketService;
